import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTASection() {
  const whatsappLink = 'https://wa.me/17863975041?text=Hola%20Ricmary%2C%20quiero%20recibir%20el%20ebook%20GRATIS%20%22El%20Blindaje%20Familiar%20en%20USA%22.%20Vivo%20en%20%5BTU%20ESTADO%5D%20y%20quiero%20orientaci%C3%B3n%20para%20proteger%20a%20mi%20familia.';
  return <section className="bg-navy py-24 px-6 relative overflow-hidden" data-id="element-44">
      {/* Background patterns */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-45">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-46" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-navy-light/50 rounded-full blur-3xl" data-id="element-47" />
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-49">
          <h2 className="font-heading text-4xl md:text-5xl text-white font-bold mb-6" data-id="element-50">
            Recibe el ebook hoy <span className="text-gold" data-id="element-51">(100% GRATIS)</span>
          </h2>

          <p className="text-xl text-cream/90 mb-10 max-w-2xl mx-auto" data-id="element-52">
            Haz clic y escríbeme por WhatsApp. Te lo envío y, si quieres, te
            ayudo a entender tu mejor opción con claridad.
          </p>

          <div className="flex flex-col items-center" data-id="element-53">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-whatsapp hover:bg-whatsapp-hover text-white px-10 py-5 rounded-xl font-bold text-xl transition-all shadow-glow hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] hover:-translate-y-1 w-full sm:w-auto" data-id="element-54">
              <MessageCircleIcon className="w-7 h-7" data-id="element-55" />
              Recibir por WhatsApp
            </a>

            <div className="mt-6 flex items-center gap-2 text-cream/60 text-sm" data-id="element-56">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-57" />
              <span data-id="element-58">Privado y seguro. No spam.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}